import React from 'react'
import { Link } from 'react-router-dom'

const Sidebar = () => {
  return (
    <div className='p-3'>
      <h5 className='text-dark'>Free Tallygen Tools</h5>
      <div className='d-flex flex-column gap-3 mt-3 ms-2'>
        <div className='sidebar_div'><Link to="/invoice-generator" className='sidebar_link'>Invoice Generator</Link></div>
        <div className='sidebar_div'><Link to="/quotation-generator" className='sidebar_link'>Quotation Generator</Link></div>
        <div className='sidebar_div'><Link to="/Payslip-generator" className='sidebar_link'>Payslip Generator</Link></div>
      </div>
    </div>
  )
}

export default Sidebar
